import { render, staticRenderFns } from "./AquaReportPage.vue?vue&type=template&id=2d97a082&scoped=true&"
import script from "./AquaReportPage.vue?vue&type=script&lang=js&"
export * from "./AquaReportPage.vue?vue&type=script&lang=js&"
import style0 from "./AquaReportPage.vue?vue&type=style&index=0&id=2d97a082&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d97a082",
  null
  
)

export default component.exports